import { render, staticRenderFns } from "./ApprovalWorkflow.vue?vue&type=template&id=ff6654e6&scoped=true&"
import script from "./ApprovalWorkflow.vue?vue&type=script&lang=js&"
export * from "./ApprovalWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalWorkflow.vue?vue&type=style&index=0&id=ff6654e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6654e6",
  null
  
)

export default component.exports